module.exports = __webpack_public_path__ + "fonts/fa-brands-400.457cb96b.woff";